import samirUndavia from "../assets/images/doctors/dr-samir-undavia.jpg";
import abhishekBhaumik from "../assets/images/doctors/dr-abhishek-bhaumik.png";
import leslieGreenberg from "../assets/images/doctors/dr-leslie-greenberg.png";

export const doctorImages = {
  samirUndavia,
  abhishekBhaumik,
  leslieGreenberg,
};

export const doctorData = [
  {
    id: 1,
    name: "Dr. Samir Undavia",
    header: "Dr. Samir Undavia",
    imageLink: "samirUndavia",
    data: [
      {
        type: "image",
        dataHeader: "Dr. Samir Undavia",
        content: "samirUndavia",
      },
      {
        type: "heading",
        dataHeader: "Dr. Samir Undavia",
        content: "Dr. Samir Undavia",
      },
      {
        type: "para",
        dataHeader: "About Dr. Samir Undavia",
        content: [
          "Dr. Samir Undavia is a highly respected, board-certified ENT (ear, nose, and throat) and facial plastic surgeon known for his exceptional skill, compassionate care, and dedication to his patients. He completed his medical degree at New York Medical College, followed by a residency in Otolaryngology-Head and Neck Surgery at Montefiore Medical Center, and advanced fellowship training in Facial Plastic & Reconstructive Surgery at the University of Texas Health Science Center.",
          "Dr. Undavia holds dual board certifications in Otolaryngology-Head and Neck Surgery and Facial Plastic & Reconstructive Surgery, reflecting his deep expertise in both functional and cosmetic procedures. Based in New Jersey, he is committed to helping patients breathe better, feel better, and regain confidence—whether treating complex sinus issues or performing delicate reconstructive work.",
          "His thoughtful approach, clear communication, and meticulous attention to detail have earned him the trust and gratitude of countless families. Known for delivering the highest quality outcomes with genuine kindness, Dr. Undavia continues to set a standard of care that truly stands out.",
          "...And he is 'our' most favorite doctor!!!",
        ],
      },

      {
        type: "link",
        dataHeader: "Practice Links",
        content: [
          {
            head: "Facial Plastic Surgeon & Rhinoplasty Specialist",
            body: "https://njent.com/samir-undavia/",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Dr. Abhishek Bhaumik",
    header: "Dr. Abhishek Bhaumik",
    imageLink: "abhishekBhaumik",
    data: [
      {
        type: "image",
        dataHeader: "Dr. Abhishek Bhaumik",
        content: "abhishekBhaumik",
      },
      {
        type: "heading",
        dataHeader: "Dr. Abhishek Bhaumik",
        content: "Dr. Abhishek Bhaumik",
      },
      {
        type: "para",
        dataHeader: "Dr. Abhishek Bhaumik's Journey",
        content: [
          "Dr. Abhishek Bhaumik discovered his passion for pediatric dentistry at age 17 while working as a pediatric dental assistant in his hometown of Katy, Texas. A lifelong martial artist and karate instructor, he realized his natural ability to connect with children and found a sense of purpose that shaped his career path.",
          "He earned a Bachelor of Arts in Biology with a minor in Chemistry from Texas A&M University and a Doctor of Dental Surgery (DDS) degree from Texas A&M Baylor College of Dentistry. He went on to complete a Master of Science (MS) degree and Certificate in Pediatric Dentistry at Texas A&M Baylor College of Dentistry, where he also trained at Children's Medical Center and Texas Scottish Rite Hospital to provide specialized care for children with functional needs.",
          "Dr. Bhaumik's personal experiences growing up as a first-generation immigrant instilled deep empathy and a commitment to helping children feel safe and supported. Today, he leads Stonebrook Pediatric Dentistry with a promise to deliver exceptional dental care while supporting children's overall wellness—all in a positive, welcoming environment.",
        ],
      },

      {
        type: "link",
        dataHeader: "Practice Links",
        content: [
          {
            head: "Stonebrook Pediatric Dentistry",
            body: "https://stonebrookpediatricdentistry.com/",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    name: "Dr. Leslie Greenberg",
    header: "Dr. Leslie Greenberg",
    imageLink: "leslieGreenberg",
    data: [
      {
        type: "image",
        dataHeader: "Dr. Leslie Greenberg",
        content: "leslieGreenberg",
      },
      {
        type: "heading",
        dataHeader: "Dr. Leslie Greenberg",
        content: "Dr. Leslie Greenberg",
      },
      {
        type: "para",
        dataHeader: "About Dr. Leslie Greenberg",
        content: [
          "Dr. Greenberg has been a cherished part of Princeton Nassau Pediatrics since 2009. She completed her pediatrics and adolescent medicine residency at Children's Hospital at Montefiore, Albert Einstein College of Medicine, and earned her medical degree from Tufts University School of Medicine. A Brandeis University graduate with a BA in sociology, Dr. Greenberg is board certified in pediatrics and a fellow of the American Academy of Pediatrics.",
          "Beyond her impressive credentials, Dr. Greenberg is beloved for her kindness, warmth, and genuine love for children. She was Ariana and Anaira's very first pediatrician, and they hold a special place in their hearts for her. When she's not caring for her patients, she enjoys baking and reading.",
          "Princeton Nassau Pediatrics is a team of board-certified pediatricians committed to delivering exceptional care for children from infancy through college. Combining the latest medical advances with compassionate, personalized attention, we support every child's health, growth, and well-being.",
        ],
      },

      {
        type: "link",
        dataHeader: "Practice Links",
        content: [
          {
            head: "Princeton Nassau Pediatrics",
            body: "https://princetonnassaupediatrics.com/people/leslie-greenberg-md/",
          },
        ],
      },
    ],
  },
];
